/* Homepage product rails: GA4 events for the mobile grid vs desktop carousel test (13 Oct 2026).
   home_rail_view   once per rail per page view, when a quarter of the rail is on screen
   home_rail_depth  once per viewed rail when the page is hidden: furthest card seen (60% visible)
   home_rail_click  a click on a card, with its position
   Params: rail (collection handle), layout (grid or carousel, read from the rendered rail), cards,
   rail_position, furthest_card, card_index. Sent through window.gtag like collection_tab_click.
   Notes: ops/cro/tests/2026-10-13-home-grid-mobile.md */
(function () {
  if (window.__gdHomeRails) return;
  window.__gdHomeRails = true;

  function send(name, params) {
    try { if (window.gtag) window.gtag('event', name, params); } catch (e) {}
  }

  function init() {
    var rails = [].slice.call(document.querySelectorAll('section.featured-collection[data-gd-rail]'));
    if (!rails.length || !('IntersectionObserver' in window)) return;
    var all = [];

    rails.forEach(function (sec, ri) {
      var grid = sec.querySelector('x-grid');
      if (!grid) return;
      var cards = [].slice.call(grid.querySelectorAll('product-card'));
      var st = { rail: sec.getAttribute('data-gd-rail'), cards: cards.length, viewed: false, furthest: 0, sent: false };
      st.layout = function () { return grid.scrollWidth > grid.clientWidth + 8 ? 'carousel' : 'grid'; };
      all.push(st);

      var railObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !st.viewed) {
            st.viewed = true;
            send('home_rail_view', { rail: st.rail, layout: st.layout(), cards: st.cards, rail_position: ri + 1 });
            railObs.disconnect();
          }
        });
      }, { threshold: 0.25 });
      railObs.observe(grid);

      var cardObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = cards.indexOf(e.target) + 1;
          if (i > st.furthest) st.furthest = i;
        });
      }, { threshold: 0.6 });
      cards.forEach(function (c) { cardObs.observe(c); });

      grid.addEventListener('click', function (ev) {
        var t = ev.target;
        if (!t || !t.closest || !t.closest('a[href*="/products/"]')) return;
        var card = t.closest('product-card');
        if (!card) return;
        send('home_rail_click', { rail: st.rail, layout: st.layout(), card_index: cards.indexOf(card) + 1, cards: st.cards });
      }, true);
    });

    function flush() {
      all.forEach(function (st) {
        if (!st.viewed || st.sent) return;
        st.sent = true;
        send('home_rail_depth', { rail: st.rail, layout: st.layout(), cards: st.cards, furthest_card: st.furthest, transport_type: 'beacon' });
      });
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
    window.addEventListener('pagehide', flush);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
